import { render, staticRenderFns } from "./ManualMotorNotice.vue?vue&type=template&id=5f01fa17&"
import script from "./ManualMotorNotice.vue?vue&type=script&lang=js&"
export * from "./ManualMotorNotice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports